import axios from 'axios'
import { API_URL } from './constants'

const API = axios.create({
    baseURL:`${API_URL[process.env.NODE_ENV]}`
})

// Auto-logout on 401 (e.g. admin disabled this account / token expired).
// We ignore 401s from auth endpoints (they legitimately 401 without meaning
// "your session ended"), and we only bounce to /login if there's actually a
// stored token — otherwise the user was just browsing public pages and a 401
// from a background fetch shouldn't force them to log in.
const AUTH_URL_WHITELIST = [
    '/auth/login',
    '/auth/signup',
    '/auth/request-password-reset',
    '/auth/reset-password',
];

const AUTH_PAGE_WHITELIST = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
];

const isAuthUrl = (url = '') => AUTH_URL_WHITELIST.some((p) => url.includes(p));
const isOnAuthPage = () =>
    typeof window !== 'undefined' &&
    AUTH_PAGE_WHITELIST.some((p) => window.location.pathname.startsWith(p));

API.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const requestUrl = error?.config?.url || '';

        if (status === 401 && !isAuthUrl(requestUrl)) {
            const hadToken = typeof window !== 'undefined' && !!localStorage.getItem('protoken');

            if (hadToken) {
                try {
                    localStorage.removeItem('protoken');
                    localStorage.removeItem('fullname');
                    localStorage.removeItem('email');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('setupTime');
                    localStorage.removeItem('profileImage');
                } catch (_) { /* ignore */ }

                if (!isOnAuthPage()) {
                    window.location.href = '/login?reason=session';
                }
            }
            // If no token was stored, the user is browsing anonymously —
            // just let the failing request reject and stay on the page.
        }
        return Promise.reject(error);
    }
);

export default API;
